import React from 'react';
import { createRoot } from 'react-dom/client';
import { App }  from './App';
import * as serviceWorker from './serviceWorker';
import { store } from './_helpers';
import { Provider } from 'react-redux';
import tiendaService from './_services/cart/tienda.service';
import { TiendaNoDisponible } from './_components/publica/TiendaNoDisponible';


// import "./styles/css/main.css";

const root = createRoot(document.getElementById('root'));

/*
 * Antes de montar se resuelve si el front corre en una tienda propia (pepe.deautopartes.ar): asi
 * ninguna pantalla arranca mostrando el sitio general para despues cambiar. En el sitio general no
 * hay llamada y resuelve en el momento.
 */
tiendaService.cargar()
  .then(() => root.render(
    <Provider store={store}>
      <App />
    </Provider>
  ))
  .catch(() => root.render(<TiendaNoDisponible />));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
